import { useQuery } from 'react-query';
import axiosInstance from './axiosInstance';
import query from './constants.api';

const useFetch = (endpoit, id, params, interval) => {
    const fetchData = () => {
        return axiosInstance('GET', endpoit, null, params, 'application/json');
    };
    return useQuery([id], () => fetchData(), {
        refetchOnWindowFocus: false,
        refetchInterval: interval
    });
};

export default useFetch;